import { Panel } from '../../../../common/panel'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import BaseContainer from './BaseContainer'
import useCallApi from './useCallApi'

const FinancePanel = ({ config, displayType }) => {
  const { label, downloadFunc, callApi, className, ratiosSelected } = config
  const [loading, data, params] = useCallApi({
    callApi,
    displayType,
    ratiosSelected,
  })
  const { currency, unitName, multiplier } = useFormatCurrency(
    SCREEN.PORTFOLIO_INSIGHTS_FINANCE,
  )

  return (
    <Panel
      label={`portfolio.finance.${label}`}
      isI18n={true}
      style={{ marginTop: 12 }}
      downloadCsv={{
        downloadFunc: () =>
          downloadFunc({
            ...params,
            currency,
            currencyUnit: {
              multiplier,
              value: unitName,
              en_Value: unitName,
            },
          }),
      }}
      className={className}
    >
      <BaseContainer callApi={callApi} isLoading={loading} data={data} />
    </Panel>
  )
}

export default FinancePanel
